<template>
<m-pageframe
    title="Reset Test Data"
>
<v-container>

    <h2>Reset Test Data</h2>

    <v-select
        label="Profile"
        :items="items"
        v-model="profile"
    />

    <v-btn
        :disabled = "profile == null || !$rc.$state.hasRedChirpStaffRoleAdministrator()"
        color="primary"
        v-on:click="onClickSetup"
    >
        Setup
    </v-btn>

    <br/><br/>
    <b>WARNING:</b>  You should almost never have to do this.  Use the new demo account (Main Menu > Admin > Reset Demo Account) instead.

    <h2 style="margin-top: 15px;">Demonstration Files and Materials</h2>

    <ul>
        <li><a href="https://files.redchirp.com/example-excel-expired-club-member-cards.xlsx">Example Excel File for Bulk Message &mdash; Club Members with Expired Credit Cards</a></li>
    </ul>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            items: ['default', 'home-health-care', 'winery'],
            profile: null,
        }
    },

    methods: {
        onClickSetup() {
            
            if ( this.$rc.inProduction() )
            {
                this.$rc.confirm(
                    'Confirm Production Reset',
                    'This is the production environment.  Confirm that you want to reset test data',
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Reset Test Data', 'value': 'confirm'},
                    ],
                
                    (response) => {
                        if (response != 'confirm') return;
                        
                        this.doSetup();
                    }
                );
            }
            else
            {
                this.doSetup();
            }
        },

        doSetup()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'SETUP: /api/v1/admin/demo',
            
                {
                    'profile' : this.profile,
                },
            
                (data) => {
                    this.checkSetup();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to setup demo');
                },
            );
        },

        checkSetup()
        {
            let interval = setTimeout(this.checkSetup, 1000);

            this.$rc.rest(
                'GET: /api/v1/admin/demo/is-demo-setup-running',
            
                {
                },
            
                (data) => 
                {
                    if ( data.is_running == false )
                    {
                        clearInterval(interval); // stop checking...
                        this.$rc.hideSpinner();
                        this.$rc.snackbar('Demo setup complete');
                        return;
                    }
                },
            
                () => {
                    
                },
            );

            
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>